/* eslint-disable */
// @ts-nocheck

/*
 * This file contains essential scripts for
 * Google Tag Manager(GTM, gtm)
 * Usercentrics(uc, uc_)
 * integration, which follows the established standards for analytics.
 *
 * Note! typescript checks and eslint rules are purposefully disabled.
 */

import { ApplicationConfigurationService } from './src/core/application-configuration';

const { GTM_ID } = ApplicationConfigurationService.getConfiguration();

const removeCookiePolicyWidgetFingerprintFromPage = (): string => {
  const COOKIE_POLICY_WIDGET_HOST_ELEMENT_SELECTOR = 'usercentrics-root';
  const COOKIE_POLICY_WIDGET_BUTTON_ELEMENT_SELECTOR = 'uc-privacy-button';
  const forceHiddenStyleForCookieWidget = `
          button[data-testid=${COOKIE_POLICY_WIDGET_BUTTON_ELEMENT_SELECTOR}] {
            display: none !important;
            visibility: hidden !important;
          }
  `;

  const observer = new MutationObserver(() => {
    const host = document.getElementById(COOKIE_POLICY_WIDGET_HOST_ELEMENT_SELECTOR);
    if (!host) {
      return;
    }

    if (host.shadowRoot) {
      const style = document.createElement('style');
      style.textContent = forceHiddenStyleForCookieWidget;
      host.shadowRoot.appendChild(style);
    }
    observer.disconnect();
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
};

const init = (w, d, s, l, i) => {
  w[l] = w[l] || [];
  w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
  const f = d.getElementsByTagName(s)[0];
  const j = d.createElement(s);
  const dl = l !== 'dataLayer' ? `&l=${l}` : '';
  j.async = true;
  j.src = `https://www.googletagmanager.com/gtm.js?id=${i}${dl}`;

  removeCookiePolicyWidgetFingerprintFromPage();
  f.parentNode.insertBefore(j, f);
};

const noscriptInit = (d, i) => {
  if (typeof d === 'undefined') return;

  const noscript = d.createElement('noscript');
  const iframe = d.createElement('iframe');

  iframe.src = `https://www.googletagmanager.com/ns.html?id=${i}`;
  iframe.height = '0';
  iframe.width = '0';
  iframe.style.display = 'none';
  iframe.style.visibility = 'hidden';

  noscript.appendChild(iframe);
  d.body.prepend(noscript);
};

init(window, document, 'script', 'dataLayer', GTM_ID);
noscriptInit(document, GTM_ID);
